import React, {useEffect, useState} from 'react'
import { Modal, Pagination, Table } from 'antd'
import CustomButton from '../../../components/CustomButton'
import Scrollbars from 'react-custom-scrollbars-2'
import { useTranslation } from "react-i18next"
import './style.css'

const ModalAudit = (props) => {
	const { visible, setVisible, columns, idRecordAudit, setIdRecordAudit, pageSize, func, tableProps, ...otherProps } = props
	const [loading, setLoading] = useState(false)
	const [state, setState] = useState({items: [], count: 0})
	const {t} = useTranslation(['common', 'action'])

	useEffect(() => {
        onPaginationAuditChange(1)
    }, [idRecordAudit])

	const onPaginationAuditChange = (value) => {
		if(idRecordAudit){
			const params = {
				id   : idRecordAudit,
				page : value,
				pageSize : pageSize
			}
			setLoading(true)
			func(params)
				.then(res => setState({items: res.items, count: res.count}))
				.finally(() => setLoading(false))
		}
	}

	const handleCancel = () => {
		setVisible(false)
		setIdRecordAudit(null)
		setState({items: [], count: 0})
	}

	const columnsAudit = [
		...columns,
		{
			title		: t('common:action'),
			dataIndex	: 'action',
			key			: 'action',
			width		: '12%'
		},
		{
			title		: t('common:date'),
			dataIndex	: 'actionDateTime',
			key			: 'actionDateTime',
			width		: '10%'
		},
		{
			title		: t('common:ip'),
			dataIndex	: 'ip',
			key			: 'ip',
			width		: '10%'
		}
	]

	return (
		<Modal
			destroyOnHidden
			footer={
				(
					<CustomButton
						type="grey"
						onClick={ handleCancel }
					>
						{t('action:close')}
					</CustomButton>
				)
			}
			title={t('common:historyOfChange')}
			open={visible}
			width={1200}
			onCancel={ handleCancel }
			{ ...otherProps }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={600}
			>
				<Table
					columns={columnsAudit}
					dataSource={state.items}
					pagination={false}
					loading={loading}
					{ ...tableProps }
				>
				</Table>
				{
					state.count > 10 && <div className="modal-audit-pagination">
						<Pagination
							showQuickJumper
							total={state.count}
							onChange={onPaginationAuditChange}
						/>
					</div>
				}
			</Scrollbars>
		</Modal>
	)
}

export default ModalAudit